import emojiRegex from 'emoji-regex'

export function getStringLength(string: string): number {
    if (!string) return 0
    const regex = emojiRegex()
    const emojiArr = string.match(regex)
    if (emojiArr != null) {
        return string.length - emojiArr.length
    } else {
        return string.length
    }
}
